import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { suggestTrack } from '../api/client.js';
import { suggesterSearchQueryKeyPrefix, suggesterViewQueryKey } from '../api/queryKeys.js';

import type { PartySlug, SuggestAck, SuggesterToken } from '@mixwire/contracts';

type SuggestVariables = {
  readonly slug: PartySlug;
  readonly token: SuggesterToken;
  /** A Spotify track id, or any link form somebody pasted. */
  readonly track: string;
};

export const useSuggestTrack = (): UseMutationResult<SuggestAck, Error, SuggestVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, token, track }: SuggestVariables) =>
      suggestTrack(slug, token, track),
    onSuccess: (_ack, { slug }) => {
      void queryClient.invalidateQueries({ queryKey: suggesterSearchQueryKeyPrefix(slug) });
      void queryClient.invalidateQueries({ queryKey: suggesterViewQueryKey(slug) });
    },
  });
};
